function onlyNumbers(tel = '') {
  return tel.replace(/[^0-9]/g, '');
}

function handleTel(tel = '') {
  if (!tel) {
    return '';
  }
  if (tel.length === 11) {
    return tel.replace(/(\d{2})(\d{5})(\d{4})/g, '($1) $2-$3');
  } if (tel.length === 10) {
    return tel.replace(/(\d{2})(\d{4})(\d{4})/g, '($1) $2-$3');
  } if (tel.length === 9) {
    return tel.replace(/(\d{5})(\d{4})/g, '$1-$2');
  }
  return tel.replace(/(\d{4})(\d{4})/g, '$1-$2');
}

export default function TelefoneFilter(telefone = '') {
  if (telefone.includes('+')) {
    return handleTel(
      onlyNumbers(telefone.replace('+55', '')),
    );
  }

  return handleTel(
    onlyNumbers(telefone),
  );
}
